import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.development';
import { Atencion } from '../../pages/pacientes/pacientes';

export interface SignosVitalesRequest {
  peso: number | null;
  estatura: number | null;
  saturacionOxigeno: number | null;
  frecuenciaRespiratoria?: number | null;
  frecuenciaCardiaca: number | null;
  glucosa: number | null;
  temperatura: number | null;
  presionSistolica: number | null;
  presionDiastolica: number | null;
  observaciones: string;
}

export interface CrearAtencionRequest {
  pacienteId: string;
  prioridad: string;
  signosVitales: SignosVitalesRequest;
}

export interface CrearSoloSignosRequest {
  pacienteId: string;
  signosVitales: SignosVitalesRequest;
}

export interface ActualizarConsultaRequest {
  padecimiento: string;
  hallazgos: string;
  impresion: string;
}

@Injectable({
  providedIn: 'root',
})
export class AtencionService {
  private atencionApiUrl = `${environment.apiUrl}/atencion`;

  constructor(private http: HttpClient) {}

  crearAtencion(datos: CrearAtencionRequest): Observable<any> {
    return this.http.post<any>(this.atencionApiUrl, datos);
  }

  guardarSoloSignos(datos: CrearSoloSignosRequest): Observable<any> {
    return this.http.post<any>(`${this.atencionApiUrl}/solo-signos`, datos);
  }

  /**
   * *Obtiene una atención específica por su ID.
   */
  obtenerAtencion(atencionId: string): Observable<Atencion> {
    return this.http.get<Atencion>(`${this.atencionApiUrl}/${atencionId}`);
  }

  /**
   * Obtiene todas las atenciones de un paciente.
   */
  obtenerAtenciones(pacienteId: string): Observable<Atencion[]> {
    return this.http.get<Atencion[]>(`${this.atencionApiUrl}/paciente/${pacienteId}`);
  }

  /**
   * Obtiene todas las atenciones que están en espera.
   */
  obtenerAtencionesEspera(): Observable<Atencion[]> {
    return this.http.get<Atencion[]>(`${this.atencionApiUrl}/espera`);
  }

  /**
   * Obtiene todas las atenciones que están actualmente en consulta.
   */
  obtenerAtencionesAtendidos(): Observable<Atencion[]> {
    return this.http.get<Atencion[]>(`${this.atencionApiUrl}/consulta`);
  }

  /**
   * Inicia una atención.
   */
  iniciarAtencion(atencionId: string): Observable<any> {
    return this.http.patch(`${this.atencionApiUrl}/${atencionId}/iniciar`, {});
  }

  /**
   * Finaliza una atención.
   */
  finalizarAtencion(atencionId: string): Observable<any> {
    return this.http.patch(`${this.atencionApiUrl}/${atencionId}/finalizar`, {});
  }

  /**
   * Cancela una atención.
   */
  cancelarAtencion(atencionId: string, motivo: string): Observable<any> {
    return this.http.patch(`${this.atencionApiUrl}/${atencionId}/cancelar`, { motivo });
  }

  actualizarConsulta(atencionId: string, datos: ActualizarConsultaRequest): Observable<any> {
    return this.http.patch(`${this.atencionApiUrl}/${atencionId}/consulta`, datos);
  }
}
